
import Vue from  'vue'

export default {

    created()
    {
        // this.eventHub.$on('popin:watch:open', this.open)
    },

    mounted()
    {
        // this._onResized = this._onResized.bind(this)

        // requestAnimationFrame(this.open.bind(this))
        this.eventHub.$on('window:resized', this._onResized)

        // setTimeout(this.$root.$children[0].removeScrollbar.bind(this), 1000)
    },

    data()
    {
    	return {
            // isOpen: false,
            size: [...this.$root.$children[0].windowSize]
    	}
    },

    methods: {

    	open()
        {
    		// this.isOpen = true
    	},

        close()
        {
            // this.isOpen = false
            // this.$root.$children[0].deliverScrollbar()
            this.eventHub.$emit('popin:watch:close')
            /*setTimeout(() => {
                this.eventHub.$emit('popin:watch:close')
            }, 1000)*/
        },

        /*onPlayerReady()
        {
        },*/

        _onResized()
        {
            this.size = [...this.$root.$children[0].windowSize]
        },
    }
}